import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class FotoPerfilService {

  private urlFoto: string;
  private urlUpdated = new Subject<string>();

  getUrlFoto() {
    return this.urlFoto;
  }

  getUrlFotoUpdateListener() {
    return this.urlUpdated.asObservable();
  }

  setUrlFoto(url: string) {
    this.urlFoto = url;
    this.urlUpdated.next(this.urlFoto);
  }
}
